import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

export const LessonDetailSkeleton: FC = () => (
  <Box>
    {/* Breadcrumbs */}
    <Box display="flex" gap={1} mb={2} alignItems="center">
      <Skeleton variant="text" width={120} height={20} />
      <Skeleton variant="text" width={8} height={20} />
      <Skeleton variant="text" width={140} height={20} />
      <Skeleton variant="text" width={8} height={20} />
      <Skeleton variant="text" width={160} height={20} />
    </Box>

    {/* Top card — description left + sidebar right */}
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 2,
        mb: 4,
        p: 3,
        borderRadius: 2,
        bgcolor: 'background.paper',
      }}
    >
      {/* Left — title + description */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Skeleton variant="text" width="50%" height={28} />
        <Skeleton variant="text" width="100%" height={18} />
        <Skeleton variant="text" width="95%" height={18} />
        <Skeleton variant="text" width="90%" height={18} />
        <Skeleton variant="text" width="85%" height={18} />
        <Box mt={1} />
        <Skeleton variant="text" width="100%" height={18} />
        <Skeleton variant="text" width="88%" height={18} />
        <Skeleton variant="text" width="75%" height={18} />
      </Box>

      {/* Right — "IN THIS LESSON" list */}
      <Box sx={{ width: { xs: '100%', md: 340 }, flexShrink: 0, p: 2, borderRadius: 2, bgcolor: 'grey.50' }}>
        <Skeleton variant="text" width={120} height={16} sx={{ mb: 2 }} />
        {Array.from({ length: 3 }).map((_, i) => (
          // oxlint-disable-next-line react/no-array-index-key
          <Box key={i} display="flex" gap={1} alignItems="flex-start" mb={1.5}>
            <Skeleton variant="circular" width={16} height={16} sx={{ mt: 0.3, flexShrink: 0 }} />
            <Skeleton variant="text" width="80%" height={18} />
          </Box>
        ))}
      </Box>
    </Box>

    {/* Video/s section */}
    <Skeleton variant="text" width={80} height={28} sx={{ mb: 2 }} />
    <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
      <Box sx={{ width: 300, flexShrink: 0 }}>
        <Skeleton variant="rectangular" width={300} height={150} sx={{ borderRadius: 2, mb: 1 }} />
        <Skeleton variant="text" width="70%" height={20} />
        <Skeleton variant="text" width={50} height={16} />
      </Box>
    </Box>

    {/* Documents section */}
    <Box sx={{ p: 3, borderRadius: 2, bgcolor: 'background.paper' }}>
      <Skeleton variant="text" width={100} height={28} sx={{ mb: 2 }} />
      <Box display="flex" gap={2}>
        <Box sx={{ width: 80, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <Skeleton variant="rectangular" width={70} height={90} sx={{ borderRadius: 1 }} />
          <Skeleton variant="text" width={70} height={16} />
        </Box>
      </Box>
    </Box>
  </Box>
);
